import { GridColDef } from "@mui/x-data-grid";
import TableData from "../../../components/Table/TableData";
import { UsuarioSysproJudType } from "../../../types/UsuarioType";
import moment from "moment";

type UsuarioProps = {
    usuarios: UsuarioSysproJudType[]
}

export default function Usuarios({ usuarios }: UsuarioProps) {
    const columns: GridColDef[] = [
        {
            field: 'nome_usuario',
            headerName: 'USUARIO',
            minWidth: 400
        },
        {
            field: 'is_advogado',
            headerName: 'TIPO',
            minWidth: 300,
            valueFormatter: (cod: any) => Number(cod) === 1 ? 'ADVOGADO' : 'USUARIO'
        },
        {
            field: 'ultimo_acesso',
            headerName: 'ULTIMO ACESSO',
            minWidth: 400,
            valueFormatter: (cod: any) => moment(cod).format("DD/MM/YYYY HH:mm")
        }
    ];

    return (
        <TableData
            columns={columns}
            rows={usuarios.map((u, i) => ({ ...u, id: i }))}
        />
    );
}